export default __webpack_public_path__ + "static/broadcastImg1-12ba2068939262d432dc457b8a4aee83.webp";